<!-- IntervalUpdate.vue -->
<script lang="ts" setup>
    import { ref, onMounted } from 'vue';
    import { interval } from '../lib/ChoiceUtils';

    const props = withDefaults(defineProps<{
        interval?: number       // Milliseconds
        }>(), {
            interval: 500
        });

    const refreshSectionKey = ref<number>(0);

    onMounted(()=>{
        startInterval();
    });

    async function startInterval()
    {
        await interval(props.interval);
        refreshSectionKey.value = 1 + refreshSectionKey.value; 

        // Trigger the next interval
        setTimeout(startInterval, 1);
    }

</script>

<template>
    <span :key="refreshSectionKey">
        <slot></slot>
    </span>
</template>